import React, { useRef, useEffect, Fragment } from "react";
import { useFormikContext } from "formik";
import { getFieldPath } from "utils/form";
import get from "lodash/get";
import { STATE_KEYS } from "utils/constants/state";
import { secondaryBackButton } from "utils/constants/ui";
import MenuNavHeader from "components/MenuNavHeader";
import DebounceTextarea from "components/DebounceTextarea";
import CheckoutShow from "./CheckoutShow";

const ProductShow = ({ name, addProduct }) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const productsPath = `${name}.data.products`;
  const paymentLinks = get(values, productsPath);
  const activeIndex = get(values, STATE_KEYS.EDITOR.MENU_ACTIVE_INDEX);
  const activePaymentLink = paymentLinks[activeIndex];

  const productPath = `${productsPath}[${activeIndex}]`;

  const scrollRef = useRef(null);
  const scrollTop = () => {
    scrollRef.current && scrollRef.current.scrollTo(0, 0);
  };

  const goBack = () => {
    setFieldValue(STATE_KEYS.EDITOR.MENU_ACTIVE_INDEX, null);
  };
  const buttonProps = secondaryBackButton({ onClick: () => goBack() });

  const uuidPath = getFieldPath(productPath, "uuid");
  const uuid = get(values, uuidPath, "");

  const titlePath = getFieldPath(productPath, "title");
  const title = get(values, titlePath, "");

  const descriptionPath = getFieldPath(productPath, "description");
  const description = get(values, descriptionPath, "");

  useEffect(() => {
    scrollTop();
  }, [activeIndex]);

  let content;
  if (activePaymentLink) {
    content = (
      <Fragment>
        <MenuNavHeader navSetters={[buttonProps]} label="Product">
          {addProduct ? (
            <div
              className="f6 fw6 link__decoration--hover color-primary pointer"
              onClick={addProduct}
            >
              Add product
            </div>
          ) : null}
        </MenuNavHeader>
        <div className="w-100 pa3">
          <label className="f6 mb2 dib fw6">Title</label>
          <DebounceTextarea
            uid={title}
            inputValue={title}
            placeholder="Product title"
            debounce={500}
            minRows={1}
            name={titlePath}
            valueSet={(val) => {
              setFieldValue(titlePath, val);
              setFieldTouched(titlePath, true);
            }}
          />
          <div className="w-100 pt3">
            <label className="f6 mb2 dib fw6">Description</label>
            <DebounceTextarea
              uid={description}
              inputValue={description}
              placeholder="Describe this product"
              debounce={500}
              minRows={1}
              name={descriptionPath}
              valueSet={(val) => {
                setFieldValue(descriptionPath, val);
                setFieldTouched(descriptionPath, true);
              }}
            />
          </div>
        </div>
        <div className="w-100">
          <div className="ph3">
            <label className="f6 mb2 dib fw6">Checkout</label>
          </div>
          <CheckoutShow activeIndex={activeIndex} name={name} uuid={uuid} />
        </div>
      </Fragment>
    );
  } else {
    console.error(`No payment link for active index ${activeIndex}`);
    content = (
      <div className="f5">No payment link. Head back and select another</div>
    );
  }

  return (
    <div
      ref={scrollRef}
      className="scrollableMenu w-100 overflow-y-scroll-ns h-100 relative bg-white bh--inset"
    >
      {content}
    </div>
  );
};

export default ProductShow;
